module.exports = __webpack_public_path__ + "img/app-store.ac0ef015.png";